import { render, staticRenderFns } from "./cardDistribut.vue?vue&type=template&id=65c9bca3&scoped=true&"
import script from "./cardDistribut.vue?vue&type=script&lang=js&"
export * from "./cardDistribut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9bca3",
  null
  
)

export default component.exports